import { ApiFetch } from '../../../shared/utils/fetch';
import { unwrap, type Enveloped } from '../../../shared/utils/unwrap';
import type {
  MerchantApplicationDetail,
  MerchantApplicationSummary,
  OnboardingActionResponse,
} from '../types';

/**
 * Calls osprey-api's `/merchant-onboarding` routes (backend PE-2077 / frontend PE-1282).
 * Every route is TCS-staff only (CollectiveOnlyGuard) + MERCHANT_ONBOARDING.READ/MANAGE,
 * enforced server-side; this client only sends the bearer ApiFetch already attaches.
 * Not tenant-scoped — applications aren't provisioned merchants yet.
 */
export const merchantApplicationsApi = {
  listPending: async (): Promise<MerchantApplicationSummary[]> => {
    const response = await ApiFetch.get<Enveloped<MerchantApplicationSummary[]>>(
      '/merchant-onboarding/pending',
    );
    return unwrap(response);
  },

  getDetail: async (id: string): Promise<MerchantApplicationDetail> => {
    const response = await ApiFetch.get<Enveloped<MerchantApplicationDetail>>(
      `/merchant-onboarding/${id}`,
    );
    return unwrap(response);
  },

  approve: async (id: string): Promise<OnboardingActionResponse> => {
    const response = await ApiFetch.post<Enveloped<OnboardingActionResponse>>(
      `/merchant-onboarding/${id}/approve`,
    );
    return unwrap(response);
  },

  reject: async (id: string, reason: string): Promise<OnboardingActionResponse> => {
    const response = await ApiFetch.post<Enveloped<OnboardingActionResponse>>(
      `/merchant-onboarding/${id}/reject`,
      { reason },
    );
    return unwrap(response);
  },
};
